import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';

const GROUP_ORDER = ['identity', 'classification', 'price', 'competition', 'supplier', 'compliance', 'dropshipping', 'reviews', 'variant'];
const GROUP_LABEL = {
    identity: 'columns.group.identity',
    classification: 'columns.group.classification',
    price: 'columns.group.price',
    competition: 'columns.group.competition',
    supplier: 'columns.group.supplier',
    compliance: 'columns.group.compliance',
    dropshipping: 'columns.group.dropshipping',
    reviews: 'columns.group.reviews',
    variant: 'columns.group.variant',
};
const LOCKED = ['image', 'name']; // fixed columns; status column is implicit (always rendered)

export default function ColumnPicker({ t, allColumns, profile, selected, onChange, onResetToProfile }) {
    const toggle = (val) => onChange(
        selected.includes(val)
            ? selected.filter(v => v !== val)
            : [...selected, val]
    );

    return (
        <div style={{ minWidth: '26em' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <strong>{t('product.fields_to_show')}</strong>
                <Button
                    label={t('columns.reset_to_profile')}
                    className="p-button-text p-button-sm"
                    onClick={onResetToProfile}
                />
            </div>
            {GROUP_ORDER.map(g => {
                const inProfile = profile.columnGroups.includes(g);
                // Groups outside the profile still surface their "always" columns
                // (e.g. seller count), so every profile can show them.
                const cols = allColumns.filter(c => c.group === g && (inProfile || c.always));
                if (!cols.length) return null;
                return (
                    <div key={g} style={{ marginBottom: 10 }}>
                        <div style={{ fontSize: '.72rem', fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', marginBottom: 4 }}>
                            {t(GROUP_LABEL[g])}
                        </div>
                        {cols.map(c => (
                            <label
                                key={c.value}
                                style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '2px 0', opacity: LOCKED.includes(c.value) ? .5 : 1 }}
                            >
                                <Checkbox
                                    checked={selected.includes(c.value)}
                                    disabled={LOCKED.includes(c.value)}
                                    onChange={() => toggle(c.value)}
                                />
                                {c.label}
                                {LOCKED.includes(c.value) && (
                                    <i className="pi pi-lock" style={{ fontSize: '.7rem', color: '#9ca3af' }} />
                                )}
                            </label>
                        ))}
                    </div>
                );
            })}
        </div>
    );
}
